import type { ReactNode } from 'react';
import { OverlayScrollArea } from '@odo/shared-ui';

export function DmModalBody({ children }: { children: ReactNode }) {
    return (
        <OverlayScrollArea className="flex-1 min-h-0" contentClassName="px-6 pb-5" trackInsetPx={6}>
            <div className="flex flex-col gap-4">{children}</div>
        </OverlayScrollArea>
    );
}
